import Form from './src/form';

Form.install = function(Vue) {
  Vue.component(Form.name, Form);
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/form/index.js